/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import Config from '@/config'

export function ui () {
  return {
    namespaced: true,
    state: {
      modalLogin: false,
      modalRegister: false,
      loader: false,
      loaderMsg: '',
      locale: process.env.VUE_APP_I18N_LOCALE,
      codeLang: '',
      cookieNotifyShowed: true,
      loadingMiniCart: false,
      showMiniCart: false,
      menu: [],
      isMobile: false,
      urlCode: '',
      storeViewCode: '',
      showSearch: false,
      countries: null,
      currentCountry: null,
      currentState: null,
      showCountriesModal: false,
      listingColumns: Config.Theme.listingColumns,
      sizeCountrySelected: Config.Theme.sizeCountries[0].value,
      hrefLang: [], // ex. { rel: 'alternate', href: 'http://localhost:8080/it_it/the-a-sneaker-brown.html', hreflang: 'es' }
      metaRobots: '', // default: INDEX,FOLLOW
      jsonLD: null,
      canonical: '',
      breadcrumb: [],
      dateTime: '',
      redirect: null,
      messages: {}
    },
    getters,
    actions,
    mutations
  }
}
